import React from "react";
import PropTypes from "prop-types";
import { CircularProgress } from "material-ui/Progress";

import styles from "./Loading.scss";

const Loading = ({ size }) => (
  <div className={styles.container}>
    <CircularProgress size={size} color="secondary" />
  </div>
);

Loading.propTypes = {
  size: PropTypes.number,
};

Loading.defaultProps = {
  size: 50,
};

export default Loading;



// WEBPACK FOOTER //
// ./src/pages/utils/loading/Loading.jsx